import * as React from 'react';
import * as SplitPane from 'react-split-pane';

const VERTICAL_PRIMARY_MIN_SIZE = 250;
const VERTICAL_PRIMARY_MAX_SIZE = 600;
const HORIZONTAL_PRIMARY_MIN_SIZE = 200;
const HORIZONTAL_PRIMARY_MAX_SIZE = 500;

interface Props {
	children: React.ReactNode[];
	minSize?: number;
}

export const ReactSplitPaneVertical: React.SFC<Props> = props => {
	return <SplitPane
		split={'vertical'}
		minSize={VERTICAL_PRIMARY_MIN_SIZE}
		defaultSize={VERTICAL_PRIMARY_MIN_SIZE}
		maxSize={VERTICAL_PRIMARY_MAX_SIZE}
	>
		{props.children}
	</SplitPane>;
};

export const ReactSplitPaneHorizontal: React.SFC<Props> = props => {
	return <SplitPane
		split='horizontal'
		minSize={props.minSize || HORIZONTAL_PRIMARY_MIN_SIZE}
		defaultSize={props.minSize || HORIZONTAL_PRIMARY_MIN_SIZE}
		maxSize={HORIZONTAL_PRIMARY_MAX_SIZE}
		primary='second'
	>
		{props.children}
	</SplitPane>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/SplitPane.tsx